<template>
  <div class="page-list">
    <waterfall
      v-if="!isEmpty"
      :col='column'
      :data="list">
      <template >
        <router-link class="view-item" v-for="item in list" :key="item.id" :to="getUrl(item)">
          <div class="view-box">
            <img class="view-img" :src="item.thumbnail_url" alt="item.name">
          </div>
          <div class="view-title">{{item.name}}</div>
          <div class="view-sumary">{{item.photo_count}}张</div>
        </router-link>
      </template>
    </waterfall>
    
  </div>
</template>

<script>
import Session from '../utils/session'
import API from '../service/API';
import '@/assets/less/list.less';
export default {
  name: "list",
  data (){
    return {
      list: [],
      column: 2,
      top: 0,
      isEmpty: false,
      isFixed: false
    }
  },
  mounted(){
    this.getList()
  },
  methods:{
    getList(){
      const id = this.$route.params.id

      let params = {};

      //场景1
      const albumCode = Session.get("albumCode") || '';
      if (albumCode !== '') {
        params = {
          albumCode: albumCode,
          ordering: '-create_time'
        }
      }

      //场景2
      const channelCode = Session.get("channelCode") || '';
      const groupCode = Session.get("groupCode") || '';
      if (channelCode !== '' && groupCode !== ''){
        params = {
          channelCode: channelCode,
          groupCode: groupCode,
          ordering: '-create_time'
        }
      }

      API.getAlbums(params).then( res => {
        this.$data.list = [...res.data]

        let albumsIds = [];
        res.data.map(item => albumsIds = albumsIds.concat(item.id));
        Session.add("albums", albumsIds.join(','));
        if (albumsIds.length > 0 && window.wx) {
          let firstAlbum = res.data.album;
          const url = location.href;
          const origin = location.origin
          API.getWxConfgi(url).then( res => {
            wx.config({ ...res});

            // wx.error(function(res){
            //   // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            //   alert(res);
            // });

            wx.ready(function () {
              wx.updateAppMessageShareData({
                title: firstAlbum['name'], // 分享标题  取标题
                desc: firstAlbum['desc'], // 分享描述  取标题
                link: `${origin}?albumCode=${firstAlbum.code}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致，  取值取当前网页路径即可
                imgUrl: firstAlbum['title_image_url'], // 分享图标， 取值取相册返回的title_image_url字段值
                success: function () {

                }
              })
            });
          })
        }

      })
    },
    getUrl(item){
      return `/album/${item.id}`;
    }
  }
}
</script>
